import { apiFetch } from '../../constants';

async function call(path, opts) {
  const res = await apiFetch(path, opts);
  let data = null;
  try { data = await res.json(); } catch { /* non-JSON error page */ }
  if (!res.ok || data?.status === 'error') {
    throw new Error(data?.message || `Server error ${res.status}`);
  }
  return data;
}

const post = (body) => ({
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body ?? {}),
});

const s = (sid) => `/netlab/sessions/${encodeURIComponent(sid)}`;

export const netlabApi = {
  areas: () => call('/generated-areas'),
  taskGrids: (taskId) => call(`/netlab/netbank/${encodeURIComponent(taskId)}/grids`),
  openNetbank: (task_id, level, grid) => call('/netlab/sessions/netbank', post({ task_id, level, grid })),
  upload: (file, crs) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('crs', crs);
    return call('/netlab/sessions/upload', { method: 'POST', body: fd });
  },
  session: (sid) => call(s(sid)),
  setCrs: (sid, crs) => call(`${s(sid)}/crs`, post({ crs })),
  catalog: (sid) => call(`${s(sid)}/catalog`),
  element: (sid, table, id) => call(`${s(sid)}/elements/${table}/${id}`),
  op: (sid, body) => call(`${s(sid)}/ops`, post(body)),
  undo: (sid) => call(`${s(sid)}/undo`, { method: 'POST' }),
  powerflow: (sid, scenario, step) => call(`${s(sid)}/powerflow`, post({ scenario, step })),
  powerflowTimeline: (sid) => call(`${s(sid)}/powerflow/timeline`),

  profileOptions: (sid, kind) => call(`${s(sid)}/profiles/options?kind=${encodeURIComponent(kind)}`),
  profilePool: (sid, category, q) =>
    call(`${s(sid)}/profiles/pool?category=${encodeURIComponent(category)}&q=${encodeURIComponent(q || '')}&limit=200`),
  profileUpload: (sid, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return call(`${s(sid)}/profiles/upload`, { method: 'POST', body: fd });
  },
  profilePreview: (sid, kind, profile, p_mw) => call(`${s(sid)}/profiles/preview`, post({ kind, profile, p_mw })),

  // Fetch + blob rather than a plain link so the session cookie is always sent
  // (dev server and backend run on different ports).
  download: async (sid, fallbackName) => {
    const res = await apiFetch(`${s(sid)}/download`);
    if (!res.ok) throw new Error(`Download failed (${res.status})`);
    const blob = await res.blob();
    const cd = res.headers.get('Content-Disposition') || '';
    const m = cd.match(/filename="?([^";]+)"?/);
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = m ? m[1] : `${fallbackName || 'netlab_net'}.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  },
};
